export default {
  LoginNotice: {
    Form: {
      Create: {
        Header: 'فرم افزودن اعلان ورود',
      },
      Edit: {
        Header: 'فرم ویرایش اعلان ورود',
      },
      Inputs: {
        Status: {
          Label: 'وضعیت',
          Pending: 'انتظار',
          Active: 'فعال',
          DeActive: 'غیرفعال',
          Expire: 'منقضی',
        },
        Type: {
          Label: 'نوع',
          Static: 'ثابت',
          Schedule: 'زمانبندی',
        },
        ShowType: {
          Label: 'نوع نمایش',
          Notices: 'اعلان',
          Discount: 'تخفیف',
        },
        Position: {
          Label: 'مکان',
          Front: 'فرانت',
          DeveloperPanel: 'دولوپر',
          Panel: 'پنل',
        },
        ApplyOn: {
          Label: 'برای',
          All: 'همه',
          NewUser: 'کاربران جدید',
        },
        Placeholder: '_INPUT_ را وارد کنید.',
        Title: 'عنوان',
        Url: 'آدرس اینترنتی',
        Code: 'کدتخفیف',
        Description: 'توضیحات',
      },
    },
  },
}
